import { Eligibility } from "../models/newsletter.models";
import { newsletterService } from "../services/newsletter.service";
import { feedbackService } from "../services/userMessage.service";

export class NewsletterSummary {
    private summaryTemplate: string;
    private eligibility: Eligibility[];

    constructor(summaryTemplate: string, eligibility: Eligibility[]) {
        this.summaryTemplate = summaryTemplate;
        this.eligibility = eligibility;
    }

    public initialize(): void {
        try {
            const nlSubscriptionSummary = document.getElementById("nl-subscription-summary");
            if (!nlSubscriptionSummary) { throw new Error("Newsletter subscription summary div not found"); }

            this.eligibility
                .filter((e) => e.canUnsubscribe === true)
                .forEach((n) => {
                    nlSubscriptionSummary.innerHTML = this.summaryTemplate;
                    nlSubscriptionSummary.style.display = "flex";

                    this.setEmail(n.email);
                    this.setLanguageIcon(n.newsletter.language);
                    this.setupUnsubscribeButton(n.newsletter.listId);
                });
        }
        catch (error) {
            console.error(error);
        }
    }

    private setLanguageIcon(language: string): void {
        const languageIcon = document.querySelector('#summary-language')
        if (!languageIcon) { throw new Error("Language icon div not found"); }
        if (language.toLowerCase().includes("french")) {
            languageIcon.innerHTML = "🇫🇷";
        } else {
            languageIcon.innerHTML = "🇬🇧";
        }
    }

    private setEmail(email: string): void {
        const emailDiv = document.querySelector('#summary-email')
        if (!emailDiv) { throw new Error("Email div not found"); }
        emailDiv.innerHTML = email;
    }

    private setupUnsubscribeButton(listId: string): void {
        const unsubscribeButton = document.querySelector('#unsubscribe-button')
        if (!unsubscribeButton) { throw new Error("Unsubscribe button not found"); }
        unsubscribeButton.addEventListener("click", () => this.handleUnsubscribe(listId));
    }

    private async handleUnsubscribe(id: string): Promise<void> {
        try {
            feedbackService.setUnsubscribeButtonLoading(true);
            const response = await newsletterService.unsubscribe(id);
            console.log(response);
            feedbackService.reloadPage();
        }
        catch (error) {
            console.error(error);
            // Optionally show error message to user
        }
        finally {
            feedbackService.setUnsubscribeButtonLoading(false);
        }
    }
} 